import styled from 'styled-components'
import { Box } from 'src/components'
import { Swiper, SwiperSlide } from 'swiper/react'
import { motion } from 'framer-motion'

export const ContentTestimonials = styled(motion(Box))`
    display: none;
    flex-direction: row;
    flex-wrap: wrap;
    height: 100%;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
        width: 700px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: flex;
        width: 1137px;
    }
`
export const ContentTestimonialsSwiper = styled(Swiper)`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    margin-top: 34px;
    .swiper-button-next {
        width: 40px;
        height: 40px;
        background: ${({ theme }) => theme.colors.carousel};
        border-radius: 60px;
        margin-right: -8px;
        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.tablet}) {
            margin-right: 0;
            background: none;
        }
    }
    .swiper-button-prev {
        width: 40px;
        height: 40px;
        background: ${({ theme }) => theme.colors.carousel};
        border-radius: 60px;
        margin-left: -8px;
        @media screen and (min-width: ${({ theme }) =>
                theme.breakpoints.tablet}) {
            margin-left: 0;
            background: none;
        }
    }
    .swiper-button-next::after,
    .swiper-button-prev::after {
        color: ${({ theme }) => theme.colors.white};
        font-size: 30px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 95%;
        display: flex;
        flex-direction: row;

        .swiper-button-next {
            width: 45px;
            height: 45px;
            margin-right: -18px;
        }
        .swiper-button-prev {
            width: 45px;
            height: 45px;
            margin-left: -18px;
        }
        .swiper-button-next::after,
        .swiper-button-prev::after {
            color: ${({ theme }) => theme.colors.white};
            font-size: 30px;
        }
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: none;
    }
`

export const ContentTestimonialsSwiperSlide = styled(SwiperSlide)`
    display: flex;
    justify-content: center;
    width: 85%;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        transform: none;
    }
`
